let log = console.log

export const initMicroApp = async (app, props) => {
  // log('>>>>>>> onBootstrap initMicroApp props', props)
  if (props?.util?.log) {
    log = props.util.log
  }
  window.isMicroApp = true
  window.$globalProp = props
  window.$mainRouter = props.util.mainRouter
  // console.log('>>>>>>> props.util', props.util)
  window.$globalUtil = props.util
  // console.log('>>>>>>> props.mockUtil', props.mockUtil)
  window.$mockUtil = props.mockUtil
}

export const initGlobalState = (app, props) => {
  // log('>>>>>>> initGlobalState props', props)
}

export const onGlobalStateChange = (state, prev) => {
  // log('>>>>>> 子应用监听到主应用改变', state)
}
